module.exports = __webpack_public_path__ + "static/img/M7.21991e94.png";